import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Illustratie from '@/components/Illustratie/Illustratie.vue'

export default Node.create({
    name: 'Illustratie',

    group: 'block',

    atom: true,

    addAttributes() {
        return {
            naam: {
                default: "attr string"
            },
            breedte: {
                default: 1200
            },
            hoogte: {
                default: 900
            },
            uitlijning: {
                default: "start"
            },
            formaat: {
                default: "image/png"
            },
            alt: {
                default: "alternatieve tekst voor figuur"
            },
            dpi: {
                default: 300
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'illustratie',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return ['illustratie', mergeAttributes(HTMLAttributes)]
    },

    addNodeView() {
        return VueNodeViewRenderer(Illustratie)
    },
})